import { LaboratoryInteractor, LaboratoryRequest, LaboratoryStructRequest } from "../../Coordinator/Laboratory/LaboratoryInteractor";

export class LaboratoryViewModel {
	private interactor: LaboratoryInteractor;

	constructor() {
		this.interactor = new LaboratoryInteractor();
	}

	public fetchSave(obj: any): PromiseLike<any> {
		var request = new LaboratoryRequest(
			obj["sgeplaboratorio"] ? parseInt(obj["sgeplaboratorio"]) : 0,
			obj["nome"] ? obj["nome"] : "",
		)
		return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res(true)
			}, e => {
				return rej(e)
			});
		})
	}

	public fetchDataOne(obj: any): PromiseLike<any> {
		var request = new LaboratoryStructRequest(obj["sgeplaboratorio"] ? parseInt(obj["sgeplaboratorio"]) : 0)
		return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}
}